angular.module('app').component('simList', {
    bindings: {
        userId: '<', // number
        testerId: '<', // number
        sims: '<', // Find the type for this
        isSupporting: '<', // boolean
        onSelect: '&' // reurns a sim
    },
    controllerAs: 'vm',
    controller: function ($location, $routeParams, $uibModal) {
        let vm = this;
        vm.selectSim = selectSim;
        vm.simTraceSummary = simTraceSummary;
        this.$onInit = function () {
            vm.isSupporting = this.isSupporting;
            renderSims(this.sims);
        };
        this.$onChanges = function (changes) {
            if (!changes.sims) {
                return;
            }
            renderSims(changes.sims.currentValue);
        };
        function renderSims(sims) {
            vm.sims = sims;
            if (!vm.selectedSim) {
                vm.selectedSim = vm.sims[0];
            }
        }
        function selectSim(sim) {
            vm.selectedSim = sim;
            this.onSelect({ sim: sim });
        }
        function simTraceSummary() {
            if (vm.selectedSim === null) {
                return;
            }
            let url = [
                'TraceSummary/',
                this.testerId,
                '/',
                vm.selectedSim.Id
            ].join('');
            $location.path(url);
        }
    },
    template: `
<div class="panel panel-primary tester-bgPanel">
    <div class="panel-heading">
        <div class="pull-right align-top">
            <a class="btn btn-info btn-xs align-top" ng-href="" ng-click="vm.simTraceSummary()" popover-trigger="'mouseenter'" uib-popover="Simulator {{vm.selectedSim.Name}} Trace summary"
                popover-animation popover-placement="above" popover-append-to-body="true">
                <i class="glyphicon glyphicon-random space-right"></i> Trace Summary {{vm.selectedSim.Id}}
            </a>
        </div>
        <span class="panel-title">
            <i class="glyphicon glyphicon-transfer space-right"></i> Simulators
        </span>
        <div class="input-group space-top">
            <span class="input-group-addon"><i class="glyphicon glyphicon-filter"></i></span>
            <input type="text" class="form-control input-sm" ng-model="simFilter.Name" placeholder="Contains...">
            <span class="input-group-addon pointer" ng-click="simFilter.Name=''"><i class="glyphicon glyphicon-remove"></i></span>
        </div>
    </div>
    <div class="panel-body fixed-panel-tester no-pad">
        <div class="list-group space-top">
            <a href="" class="list-group-item" ng-if="vm.sims.length == 0">
                <span class="text-muted">No simulators have been assigned for this user</span>
            </a>
            <a ng-href="" class="list-group-item pointer" ng-repeat="sim in vm.sims | filter: simFilter" ng-click="vm.selectSim(sim)"
                ng-class="{'active' : sim.Id === vm.selectedSim.Id}">
                <i ng-class="{
                                            'fa-spin' : sim.Status == 'running', 
                                            'traffic-success' : sim.Status == 'running',
                                            'traffic-warning' : sim.Status == 'unknown',
                                            'traffic-danger' : sim.Status == 'not running'}" class="fa fa-cog fa-lg space-right"
                    popover-trigger="'mouseenter'" uib-popover="Simulator {{sim.Status}} " popover-animation popover-placement="above"
                   popover-append-to-body="true"></i>
                {{sim.Name}}
            </a>
        </div>
    </div>

</div>
`
});
